import KwilDB from "kwildb"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import TableButton from "./TableButton";

export default function TableList({ privKey, secret, schema, loadedMoat }) {
    const [tables, setTables] = useState([])
    const schemaName = useSelector((state) => state.toggleControl.schema)
    const tableName = useSelector((state) => state.toggleControl.table)


    useEffect(() => {
        setTimeout(async function () {
            const kwilDB = KwilDB.createConnector(
                {
                    host: "test-db.kwil.xyz",
                    protocol: "https",
                    port: null,
                    moat: loadedMoat,
                    privateKey: JSON.parse(privKey)
                },
                secret
            )
            let temp = (
                await kwilDB.query(`SELECT table_name
                                                    FROM information_schema.tables
                                                    WHERE table_schema = '${schema}';`) 
            ).rows
            setTables(temp)
        })
    }, [privKey])
    
    return(
        <>
            {tables.map((table, index) => {
                return(
                    <TableButton
                        table={table}
                        index={index}
                        tableName={tableName}
                        schemaName={schemaName}
                        schema={schema}
                    />
                )
            })}
        </>
    )
}